// extracted by mini-css-extract-plugin
export default {"fa_button":"fa_button","fa_edit":"fa_edit","fa_font":"fa_font","fa_img":"fa_img","fa_label":"fa_label"};